import axios from "@/axios";

export const namespaced = true

export const state = {
    notifications: [],
    notificationsAlreadyShown: false
}

export const getters = {
    notificationsAlreadyShown: (state) => { return state.notificationsAlreadyShown },
    notifications: function (state) {
        return state.notifications;
    },
}

export const mutations = {
    SET_NOTIFICATIONS: (state, response) => (state.notifications = response.data),
    SET_NOTIFICATIONS_ALREADY_SHOWN: (state, response) => (state.notificationsAlreadyShown = response),
    CLEAR_DATA(state) {
        state.notificationsAlreadyShown = false;
    }
}

export const actions = {
    async getNotifications({ commit }) {
        commit('SET_NOTIFICATIONS', await axios.get("/api/notifications"))
    },
    setNotificationsAlreadyShown({ commit }, trueOrFalse) {
        commit("SET_NOTIFICATIONS_ALREADY_SHOWN", trueOrFalse);
    },
    clearData({ commit }) {
        commit("CLEAR_DATA");
    },
}
